import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SearchResult } from '../../api/models/search-result';

@Component({
  selector: 'app-search-secondary-navigation',
  templateUrl: './search-secondary-navigation.component.html',
  styleUrls: ['./search-secondary-navigation-filter-dropdown.scss', './search-secondary-navigation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchSecondaryNavigationComponent {
  @Input()
  searchResult?: SearchResult;
  constructor() {}
}
